import React, { useRef, useCallback, useContext } from 'react'
import {
  StyledTypeahead,
  StyledClearButton,
  StyledAsyncTypeahead,
} from './Dropdown.style'
import { BsArrowRightCircle } from 'react-icons/bs'
import { I18nContext } from 'i18n'

const Dropdown = (
  {
    source,
    className,
    setFocus,
    showRightIcon = false,
    handleIconClick,
    flip = true,
    disableOption,
    searchKey,
    searchOnEnter,
    onChange,
    ...props
  },
  parentRef
) => {
  const { translate } = useContext(I18nContext)
  const ownRef = useRef()
  const ref = parentRef || ownRef

  const clearButton = useCallback(
    ({ onClear, text }) => {
      function onClearAction(...args) {
        if (ref.current) ref.current.focus()
        else if (setFocus) setFocus(props.name)
        return onClear(...args)
      }
      return (
        <span>
          {showRightIcon && !!text?.length && (
            <BsArrowRightCircle
              color="rgba(0,0,0,0.6)"
              size={16}
              style={{
                position: 'absolute',
                right: 30,
                top: 7,
                cursor: 'pointer',
                zIndex: 1,
              }}
              title={translate('search_input_tooltip')}
              onClick={(e) => addCustomValue(text)}
            />
          )}
          <div className="rbt-aux">
            {!!text?.length && <StyledClearButton onClick={onClearAction} />}
          </div>
        </span>
      )
    },
    [setFocus]
  )

  const addCustomValue = (value) => {
    const items = [...ref.current.state.selected, value]
    if (props.multiple) {
      ref.current.state.selected = items
      ref.current.state.text = ''
    }
    onChange(items, ref)
    ref.current.hideMenu()
  }

  const searchProps = searchOnEnter
    ? {
        onKeyDown(e) {
          const {
            keyCode,
            target: { value },
          } = e
          if (keyCode === 13) {
            // Enter key pressed
            addCustomValue(value)
          }
          if (props.onKeyDown) props.onKeyDown(e)
        },
      }
    : {}

  const Widget = props.paginate ? StyledAsyncTypeahead : StyledTypeahead

  return (
    <Widget
      id="dropdown" // Override if needed
      labelKey="name"
      options={source}
      ref={ref}
      inputProps={{
        autoComplete: 'nope',
        className,
      }}
      flip={flip}
      isRightIcon={showRightIcon}
      onChange={(value) => onChange(value, ref)}
      {...props}
      {...searchProps}
    >
      {clearButton}
    </Widget>
  )
}

export default React.forwardRef(Dropdown)
